import React from 'react';
import { useLeadStore } from '@/store/useLeadStore';
import { Card } from '../UI/Card';
import { Button } from '../UI/Button';
import { ESTIMATION_TYPES } from '@/utils/constants';

export const Step2TypeEstimation: React.FC = () => {
  const { formData, setEstimationType, nextStep, previousStep } = useLeadStore();

  const handleSelect = (type: 'prix' | 'loyer') => {
    setEstimationType(type);
    setTimeout(() => nextStep(), 300);
  };

  return (
    <div className="animate-fade-in">
      <h2 className="text-[28px] font-light tracking-tight mb-2">Type d'évaluation</h2>
      <p className="text-sm text-secondary mb-10">
        Sélectionnez le type d'estimation souhaitée
      </p>

      <div className="mb-10">
        {ESTIMATION_TYPES.map((type) => (
          <Card
            key={type.value}
            title={type.title}
            description={type.description}
            selected={formData.estimationType === type.value}
            onClick={() => handleSelect(type.value)}
          />
        ))}
      </div>

      <div className="flex gap-3">
        <Button variant="secondary" onClick={previousStep}>
          Retour
        </Button>
      </div>
    </div>
  );
};
